import { Reducer } from 'redux';
import {
  DELETE_DESK_OPENING_EXCEPTION,
  DeskOpeningExceptionActionTypes,
  DeskOpeningExceptionState,
  GET_DESK_OPENING_EXCEPTION_LIST,
  POST_DESK_OPENING_EXCEPTION,
  PUT_DESK_OPENING_EXCEPTION,
} from '../types/deskopeningexception.types';

const initialState: DeskOpeningExceptionState = {
  deskOpeningExceptions: [],
  selectedDeskOpeningException: null,
  postSuccess: null,
  lastFetch: null,
};

export const deskOpeningExceptionReducer: Reducer<DeskOpeningExceptionState> = (
  state: DeskOpeningExceptionState = initialState, action
) => {
  const timeOfAction = new Date().getTime();

  switch ((action as DeskOpeningExceptionActionTypes).type) {
    case GET_DESK_OPENING_EXCEPTION_LIST:
      return {
        ...state,
        deskOpeningExceptions: action.payload.deskOpeningExceptions,
        selectedDeskOpeningException: null,
        postSuccess: null,
        lastFetch: timeOfAction
      };
    case POST_DESK_OPENING_EXCEPTION:
      return {
        ...state,
        postSuccess: true,
        selectedDeskOpeningException: action.payload.newDeskOpeningException,
        lastFetch: timeOfAction
      };
    case PUT_DESK_OPENING_EXCEPTION:
      return {
        ...state,
        selectedDeskOpeningException: action.payload.selectedDeskOpeningException,
        postSuccess: true,
        lastFetch: timeOfAction
      };
    case DELETE_DESK_OPENING_EXCEPTION:
      return {
        ...state,
        selectedDeskOpeningException: null,
        lastFetch: timeOfAction
      };
    default:

      return state;
  }
};
